const allDataCommunity = {
    categoryComp : {
        categoryComp1: {
            lgUrl:"https://assets2.razerzone.com/images/pnx.assets/4ba81e9537f3b39f0ff8768ef1a2165c/razer-brand-campaign-2022-category-1920x700-desktop.jpg",
            mdUrl:"https://assets2.razerzone.com/images/pnx.assets/4ba81e9537f3b39f0ff8768ef1a2165c/razer-brand-campaign-2022-category-450x480-mobile.jpg",
            title:"WIN IT YOUR WAY",
            des:"",
            lUrl:"/"
        },
        categoryComp2: {
            lgUrl:"https://assets2.razerzone.com/images/pnx.assets/a53db448965f99aee538831a3e3df0f1/razer-community.jpg",
            mdUrl:"https://assets2.razerzone.com/images/pnx.assets/a53db448965f99aee538831a3e3df0f1/razer-community-450x480-mobile.jpg",
            title:"DON’T KNOW WHERE TO BEGIN? START YOUR JOURNEY HERE.",
            des:"",
            lUrl:"/"
        },
        categoryComp3: {
            lgUrl:"https://assets2.razerzone.com/images/pnx.assets/0b335ec990ba572534f8215e14e8008c/razer-community-stream.jpg",
            mdUrl:"https://assets2.razerzone.com/images/pnx.assets/0b335ec990ba572534f8215e14e8008c/razer-community-stream-450x480-mobile.jpg",
            title:"WANT TO KNOW THE NEXT TIME WE GO LIVE ON STREAM?",
            des:"",
        },
        categoryComp4: {
          lgUrl:"https://assets2.razerzone.com/images/pnx.assets/c76379f9591f69e1df778c1354aac718/razer-esports.jpg",
          mdUrl:"https://assets2.razerzone.com/images/pnx.assets/c76379f9591f69e1df778c1354aac718/razer-esports-450x480-mobile.jpg",
          title:"GAME FOR SOME COMPETITION? LEARN MORE ABOUT TEAM RAZER.",
          des:"",
          lUrl:"/"
        },
        categoryComp5: {
        lgUrl:"https://assets2.razerzone.com/images/pnx.assets/c126593c168b557f2d7f3f0f596f4364/services-gift-card.jpg",
        mdUrl:"https://assets2.razerzone.com/images/pnx.assets/c126593c168b557f2d7f3f0f596f4364/services-gift-card-mobile.jpg",
        title:"RAZER GIFT CARD - GIVE THE GIFT OF GAMING",
        des:"The Razer Gift Card unlocks the ultimate gifts for any gamer. From gaming peripherals to laptops to apparel, redeem from the largest catalog of Razer gear in the world, including rare and exclusive products only found on Razer.com. Recipients also enjoy 14-day risk free returns, and comprehensive customer support.",
        lUrl:"/"
        },
        categoryComp6: {
      lgUrl:"https://assets2.razerzone.com/images/pnx.assets/cd51cc9a2c8e89918bcce4a6b66132d3/services-razer-care.jpg",
      mdUrl:"https://assets2.razerzone.com/images/pnx.assets/cd51cc9a2c8e89918bcce4a6b66132d3/razer-care-768x500-mobile.jpg",
      title:"RAZERCARE",
      des:"Protect your Razer gear with RazerCare—includes extended warranty that covers both mechanical and electrical issues due to normal product usage.",
      lUrl:"/"
      },
      categoryComp7: {
      lgUrl:"https://assets2.razerzone.com/images/pnx.assets/5650df732c97f6ce9e0c813fc57b9605/services-razer-id.jpg",
      mdUrl:"https://assets2.razerzone.com/images/pnx.assets/5650df732c97f6ce9e0c813fc57b9605/services-razer-id.jpg",
      title:"RAZER ID",
      des:"Gain a competitive advantage and leverage on our support, expertise and community with your Razer ID. Integrated with Razer's services and software, you can gain access to tons of tools with your Razer ID—including buying the best gamer gear on our site, redeeming Razer Silver, saving your personalized configs in Synapse, and more.",
      lUrl:"/"
      },
    },
    topDrawer : {
      data1 : [
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-getstarted.svg",
        title: "Get Started",
        link: "/",
      },
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-esports.svg",
        title: "Esports",
        link: "/",
      },
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-razerstreamer.svg",
        title: "#RazerStreamer",
        link: "/pc",
      },
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-events.svg",
        title: "Events",
        link: "/console",
      },
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-insider.svg",
        title: "Insider",
        link: "/",
      },
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-student.svg",
        title: "Student",
        link: "/",
      },
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-wallpapers.svg",
        title: "Wallpapers",
        link: "/",
      },
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-stickers.svg",
        title: "Stickers",
        link: "/",
      },
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-developers.svg",
        title: "Developers",
        link: "/",
      },
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-sustainability.svg",
        title: "Sustainability",
        link: "/",
      }
    ],
  }
}


export default allDataCommunity